import { TFunction } from "i18next";
import * as yup from "yup";
import { DocumentsToValidate } from "./types";

const translationPrefix = "q-ai.funds.signing";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fundSigningValidationSchema = (
  t: TFunction,
  documentsToValidate: DocumentsToValidate | undefined
) =>
  yup
    .object({
      confirmsAcquisitionOfShareholding: yup
        .boolean()
        .oneOf(
          [true],
          t(
            `${translationPrefix}.naturalPerson.acquisitionOfShareholding.required`
          )
        ),
      acquisitionOfShareholdingFileClicked:
        documentsToValidate?.acquisitionOfShareholdingFile
          ? yup
              .boolean()
              .oneOf(
                [true],
                t(
                  `${translationPrefix}.acquisitionOfShareholding.documentClickRequired`
                )
              )
          : yup.boolean().notRequired(),
      confirmsRiskOfAcquisition: yup
        .boolean()
        .oneOf(
          [true],
          t(`${translationPrefix}.naturalPerson.riskOfAcquisition.required`)
        ),
      riskOfAcquisitionFileClicked: documentsToValidate?.riskOfAcquisitionFile
        ? yup
            .boolean()
            .oneOf(
              [true],
              t(`${translationPrefix}.riskOfAcquisition.documentClickRequired`)
            )
        : yup.boolean().notRequired(),
      confirmsTrustAndAdministrationContract: yup
        .boolean()
        .oneOf(
          [true],
          t(
            `${translationPrefix}.naturalPerson.trustAndAdministrationContract.required`
          )
        ),
      trustAndAdministrationContractFileClicked:
        documentsToValidate?.trustAndAdministrationContractFile
          ? yup
              .boolean()
              .oneOf(
                [true],
                t(
                  `${translationPrefix}.trustAndAdministrationContract.documentClickRequired`
                )
              )
          : yup.boolean().notRequired(),
      confirmsActingOnOwnBehalf: yup
        .boolean()
        .oneOf(
          [true],
          t(`${translationPrefix}.common.actingOnOwnBehalf.required`)
        ),
    })
    .required();

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const validationSchemaFinviaLegalStructure = (
  t: TFunction,
  documentsToValidate?: DocumentsToValidate | undefined
) =>
  yup
    .object({
      signing: fundSigningValidationSchema(t, documentsToValidate),
    })
    .required();

export type AIFundContractSigning = yup.InferType<
  ReturnType<typeof validationSchemaFinviaLegalStructure>
>;

export interface AIFundContractSigningForm {
  signing?: AIFundContractSigning["signing"];
}

export function validate(
  fundSigningDeclarations: AIFundContractSigningForm
): Promise<any> {
  const t = (k: any) => k;
  return validationSchemaFinviaLegalStructure(t).validate(
    fundSigningDeclarations
  );
}
